<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs6 mb-3>
          <h1 class="max">Extrato Smartbank</h1>
        </v-flex>
        <v-flex xs6 mb-3 text-xs-right>
          <h1 @click="loadBalance()" class="max" v-if="showBalance" style="cursor: pointer;">Saldo: {{balance}}</h1>
          <h1 class="max" v-if="balanceLoading" style="cursor: pointer;">Carregando saldo</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 px-3>
          <v-flex xs12 md4 lg5 px-1>
            <DefaultFilterDate ref="filterDateFrom" kind="date" @reload="this.reloadFilterDateFrom" />
          </v-flex>
          <v-flex xs12 md4 lg5 px-1>
            <DefaultFilterDate ref="filterDateTo" kind="date" @reload="this.reloadFilterDateTo" />
          </v-flex>
          <v-flex xs12 md4 lg2 class="align-contents-right">
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="reloadRecords()">
              Update
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <div class="mt-3" v-if="statementLoaded == 'not_loaded'">Carregando transações...</div>
          <div class="mt-3" v-if="statementLoaded == 'error'">Algo errado. Não foi possível carregar as transações.</div>
          <div class="mt-3" v-if="statementLoaded == 'not_authorized'">Não foi possível carregar as transações. Você não foi autorizado.</div>
          <div class="mt-3" v-if="statementLoaded == 'empty'">Não existem transações bancárias neste momento.</div>
          <transition name="fade">
           <v-card class="mb-3 pt-4 mt-3 px-5" style="border-radius: 10px;" v-if="statementLoaded == 'ok'">
                 <v-flex xs12 pa-0 text-xs-left text-sm-right px-1>
                   <div class="font-weight-thin">
                     <span @click="downloadCsv" class="nowrap subtitle rounded-chip mr-3" v-if="csvEnabled">
                       Download CSV
                     </span>
                     Registros: {{records.length}}
                   </div>
                 </v-flex>
                 <v-flex xs12 pa-0 pb-0>
                   <v-text-field v-model="filter" class="search-filter" append-icon="search"></v-text-field>
                 </v-flex>
                 <v-flex xs12>
                   <DefaultDataTable
                     :headers="headers"
                     :items="records"
                     :loading="loading"
                     :no-data-text="i18n('Nenhuma transação registrada')"
                   >
                     <template v-slot:items="props">
                       <tr :class="[classFor(props.item)]">
                         <td class="text-xs-left"><span>{{ insertedDate(props.item.timestamp) }}</span><br /><span class="font-weight-light">{{ insertedTime(props.item.timestamp) }}</span></td>
                         <td class="text-xs-left"><span>{{ props.item.description }}</span></td>
                         <td class="text-xs-left">
                           <span v-if="!props.item.details">{{i18n('Carregando')}}</span>
                           <span v-if="props.item.details && props.item.details.not_available">N/A</span>
                           <span v-if="props.item.details && !props.item.details.not_available && props.item.nature === 'CREDIT'">{{i18n('Origem')}}: {{originBankAccount(props.item.details)}}<br />{{originName(props.item.details)}} {{originCpfCnpj(props.item.details)}}</span>
                           <span v-if="props.item.details && !props.item.details.not_available && props.item.nature === 'DEBIT'">{{i18n('Destino')}}: {{favoredBankAccount(props.item.details)}}<br />{{favoredName(props.item.details)}} {{favoredCpfCnpj(props.item.details)}}</span>
                         </td>
                         <td class="text-xs-center"><span>{{ props.item.historic }}</span></td>
                         <td class="text-xs-center"><span>{{ props.item.sourceId }}</span></td>
                         <td class="text-xs-center"><span>{{ props.item.status }}</span></td>
                         <td class="text-xs-right"><span>{{l(props.item.value, 'BRL')}}</span></td>
                       </tr>
                     </template>
                   </DefaultDataTable>
                   <v-layout row wrap my-5>
                     <v-flex xs6 pr-2>
                       <v-btn class="btn-style ma-0 mr-2" block dark @click="loadPreviousPageRecords" v-show="hasPreviousPage"><v-icon left dark>skip_previous</v-icon> {{i18n('Mais Recentes')}}</v-btn>
                     </v-flex>
                     <v-flex xs6 pl-2>
                       <v-btn class="btn-style--secondary ma-0 mr-2" block dark @click="loadNextPageRecords" v-show="hasNextPage">{{i18n('Mais Antigas')}} <v-icon right dark>skip_next</v-icon></v-btn>
                     </v-flex>
                   </v-layout>
                 </v-flex>

             <v-card-actions v-if="false">
               <v-layout column>
                 <v-flex xs12>
                   <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" @click="requestMoreRecords">
                     EXIBIR MAIS
                   </v-btn>
                 </v-flex>
               </v-layout>
             </v-card-actions>
           </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import DefaultDataTable from "./components/DefaultDataTable"
import utils from "./shared/Utils"

export default {
  name: 'AdminSmartbankStatement',
  components: { layout: LeftBarLayout, DefaultFilterDate, DefaultDataTable },
  data(vm) {
    return {
      records: [],
      headers: [
        { text: vm.i18n('Data'), value: 'timestamp', align: 'left', sortable: false },
        { text: vm.i18n('Descrição'), value: 'description', align: 'left', sortable: false },
        { text: vm.i18n('Origin/Destino'), value: 'value', align: 'left', sortable: false },
        { text: vm.i18n('Histórico'), value: 'historic', align: 'center', sortable: false },
        { text: vm.i18n('Id Origem'), value: 'sourceId', align: 'center', sortable: false },
        { text: vm.i18n('Status'), value: 'status', align: 'center', sortable: true },
        { text: vm.i18n('Valor'), value: 'value', align: 'right', sortable: false }
      ],
      loading: false,
      filterDate: null,
      filterDateFrom: null,
      filterDateTo: null,
      statementLoaded: 'not_loaded',
      filter: '',
      total_records: 0,
      total_records_loaded: 0,
      balance: false
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.resetFilter()
    this.loadBalance()
    this.loadSmartbankStatement()
  },
  computed: {
    csvEnabled() {
      return this.total_records > 0 && this.total_records == this.total_records_loaded
    },
    showMoreBtn() {
      return false
    },
    hasPreviousPage() {
      return false
    },
    hasNextPage() {
      return false
    },
    showBalance() {
      if (this.balance === 'loading') return false
      if (this.balance === false) return false
      return true
    },
    balanceLoading() {
      if (this.balance === 'loading') return true
      return false
    }
  },
  methods: {
    updateRecord(timestamp, details) {
      const index = this.records.findIndex(el => el.timestamp === timestamp)
      if (index > -1) {
        let record = this.records[index]
        record.details = details
        this.records.splice(index, 1, record)
      }
    },
    detailsUrlFor(statement_row) {
      const is_pix = [9194, 9196].includes(statement_row.historic)
      const urls = this.$root.urls

      if (is_pix) {
        return `${urls.admin__smartbank_pix_details}${statement_row.historic}/${statement_row.sourceId}`
      } else {
        if (statement_row.nature === 'CREDIT') {
          return `${urls.admin__smartbank_credit_details}${statement_row.sourceId}`
        } else {
          return `${urls.admin__smartbank_debit_details}${statement_row.sourceId}`
        }
      }
    },
    loadDetailsFor(statement_row) {
      const row_timestamp = statement_row.timestamp
      const url = this.detailsUrlFor(statement_row)

      this.$http.get(url, { headers: { Authorization: `Bearer ${this.$cookies.get('api_token')}` }}).then(
        (response) => {
          if (response.body.data) { this.updateRecord(row_timestamp, response.body.data) }
          this.total_records_loaded = this.total_records_loaded + 1
        },
        (response) => {
          if (response.body.error) { this.updateRecord(row_timestamp, {not_available: true}) }
          this.total_records_loaded = this.total_records_loaded + 1
        }
      )
    },
    loadBalance() {
      this.balance = 'loading'
      this.$http.get(`${this.$root.urls.admin__smartbank_balance}`, { headers: { Authorization: `Bearer ${this.$cookies.get('api_token')}` }}).then(
        (response) => {
          if (response.body.data) {
            this.balance = utils.currencyToLocal(response.body.data, 'BRL')
          } else {
            this.balance = 'N/A'
          }
        },
        (response) => {
          this.balance = 'N/A'
        }
      )
    },
    loadPreviousPageRecords() {
      return false
    },
    loadNextPageRecords() {
      return false
    },
    i18n(str) {
      return this.$root.l(str)
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    insertedDate(record) {
      return record.split('T')[0].split('-').reverse().join('/')
    },
    insertedTime(record) {
      const splited_time = record.split('T')[1].split(':')
      const seconds = splited_time[2].split('.')[0]
      return `${splited_time[0]}:${splited_time[1]}:${seconds}`
    },
    reloadRecords() {
      this.records = []
      this.statementLoaded = 'not_loaded'
      this.loadSmartbankStatement()
    },
    resetFilter() {
      const now = new Date(Date.now())
      const today = now.toISOString().split('T')[0]
      this.filterDateFrom = today
      this.$refs.filterDateFrom.filterDate = today
      this.filterDateTo = today
      this.$refs.filterDateTo.filterDate = today
    },
    reloadFilterDateFrom(filter_date) {
      this.filterDateFrom = filter_date
    },
    reloadFilterDateTo(filter_date) {
      this.filterDateTo = filter_date
    },
    loadSmartbankStatement() {
      this.total_records = 0
      this.total_records_loaded = 0

      let successCallback = (response) => {
        this.loading = false

        if (response.body.data) {
          this.records = response.body.data
          this.total_records = this.records.length

          response.body.data.forEach(row => {
            this.loadDetailsFor(row)
          })

          this.statementLoaded = (this.records.length === 0) ? 'empty' : 'ok'
        } else {
          this.statementLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        this.loading = false

        if (response.status === 401) {
          this.statementLoaded = 'not_authorized'
        } else {
          this.statementLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      let fromDate = this.filterDateFrom
      let toDate = this.filterDateTo

      if(fromDate && toDate) {
        const params = { from: fromDate.split('T')[0], to: toDate.split('T')[0] }
        this.loading = true
        let token = this.$cookies.get('api_token')
        this.$http.get(this.$root.urls.admin__smartbank_statement, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      }
    },
    requestMoreRecords(e) {
    },
    downloadCsv() {
      const header_line = ['DATE', 'NATURE', 'DESCRIPTION', 'SOURCE_ID', 'DOCUMENT', 'NAME', 'BANK_ACCOUNT', 'VALUE', 'STATUS']

      const parseValue = (str) => {
        if (str === null) {
          return ''
        }
        if (typeof(str) === 'undefined') {
          return ''
        }
        return String(str).split('.').join(',')
      }

      const parseDate = (d) => {
        const splitted = d.split('T')
        const date = splitted[0]
        const time = splitted[1].split('.')[0]
        return date + ' ' + time
      }

      const rows = this.records.reduce( ( rows, record ) => {
        let row = []
        const multiplier = (record.nature === 'CREDIT') ? 1 : -1
        const datetime = record.timestamp
        const description = record.description
        const source_id = record.sourceId
        const nature = record.nature
        const value = record.value * multiplier
        const status = record.status
        let document = (record.details && record.details.not_available && 'N/A') || ''
        let name = (record.details && record.details.not_available && 'N/A') || ''
        let bank_account = (record.details && record.details.not_available && 'N/A') || ''

        if (nature === 'CREDIT') {
          document = (record.details && this.originCpfCnpj(record.details)) || ''
          name = (record.details && this.originName(record.details)) || ''
          bank_account = (record.details && this.originBankAccount(record.details)) || ''
        }
        if (nature === 'DEBIT') {
          document = (record.details && this.favoredCpfCnpj(record.details)) || ''
          name = (record.details && this.favoredName(record.details)) || ''
          bank_account = (record.details && this.favoredBankAccount(record.details)) || ''
        }

        row.push(parseDate(datetime))
        row.push(nature)
        row.push(description)
        row.push(source_id)
        row.push(document)
        row.push(name)
        row.push(bank_account)
        row.push(parseValue(value))
        row.push(status)

        rows.push(row)
        return rows
      }, [header_line])

      utils.exportToCsv('smartbank_statement_report.csv', rows, ';')
    },
    isPix(obj) {
      return ['TRANSFER_SENT_PIX', 'TRANSFER_RECEIVED_PIX'].includes(obj.historicTransactionEnum)
    },
    originBankAccount(obj) {
      if (this.isPix(obj)) { return this.pixOriginBankAccount(obj) }
      if (!obj.origin) { return '' }
      if (obj.not_available) { return 'N/A' }
      const account = obj.origin
      const internal = false
      const bank = { code: account.financialInstitution.code, name: account.financialInstitution.name }
      const account_number = account.account
      const branch_number = account.agency
      const bank_account = { bank, branch_number, account_number, bank }

      return utils.longAccountName(bank_account)
    },
    originName(obj) {
      if (this.isPix(obj)) { return this.pixOriginName(obj) }
      if (obj.not_available) { return 'N/A' }
      return obj.origin.name
    },
    originCpfCnpj(obj) {
      if (this.isPix(obj)) { return this.pixOriginCpfCnpj(obj) }
      if (obj.not_available) { return 'N/A' }
      const document_type = (obj.origin.typePerson === 'PHYSICAL_PERSON') ? 'cpf' : 'cnpj'
      return utils.mask(document_type, obj.origin.cpfCnpj)
    },
    favoredBankAccount(obj) {
      if (this.isPix(obj)) { return this.pixFavoredBankAccount(obj) }
      if (obj.not_available) { return 'N/A' }
      if (!obj.favored) { return '' }
      const account = obj.favored.favoredAccount[0]
      const internal = false
      const bank = { code: account.financialInstitution.code, name: account.financialInstitution.name }
      const account_number = account.accountNumber
      const branch_number = account.agencyNumber
      const bank_account = { bank, branch_number, account_number, bank }

      return utils.longAccountName(bank_account)
    },
    favoredName(obj) {
      if (this.isPix(obj)) { return this.pixFavoredName(obj) }
      if (obj.not_available) { return 'N/A' }
      return obj.favored.ownerName
    },
    favoredCpfCnpj(obj) {
      if (this.isPix(obj)) { return this.pixFavoredCpfCnpj(obj) }
      if (obj.not_available) { return 'N/A' }
      const document_type = (obj.favored.personType === 'PHYSICAL_PERSON') ? 'cpf' : 'cnpj'
      return utils.mask(document_type, obj.favored.cpfCnpj)
    },
    pixFavoredBankAccount(obj) {
      if (obj.not_available) { return 'N/A' }
      if (!obj.sentMovementPix) { return 'N/A' }
      if (!obj.sentMovementPix.receiverNameBank) { return 'N/A' }

      const bank_name = obj.sentMovementPix.receiverNameBank
      const branch_number = obj.sentMovementPix.receiverAgency
      const account_number = obj.sentMovementPix.receiverAccount

      return `${bank_name} Ag ${branch_number} CC ${account_number}`
    },
    pixFavoredName(obj) {
      if (obj.not_available) { return 'N/A' }
      if (!obj.sentMovementPix) { return 'N/A' }
      if (!obj.sentMovementPix.receiverName) { return 'N/A' }
      return obj.sentMovementPix.receiverName
    },
    pixFavoredCpfCnpj(obj) {
      if (obj.not_available) { return 'N/A' }
      if (!obj.sentMovementPix) { return 'N/A' }
      if (!obj.sentMovementPix.receiverDocumentNumber) { return 'N/A' }
      return obj.sentMovementPix.receiverDocumentNumber
    },
    pixOriginBankAccount(obj) {
      if (obj.not_available) { return 'N/A' }
      if (!obj.receivedMovementPix) { return 'N/A' }
      if (!obj.receivedMovementPix.payerNameBank) { return 'N/A' }

      const bank_name = obj.receivedMovementPix.payerNameBank
      const branch_number = obj.receivedMovementPix.payerAgency
      const account_number = obj.receivedMovementPix.payerAccount

      return `${bank_name} Ag ${branch_number} CC ${account_number}`
    },
    pixOriginName(obj) {
      if (obj.not_available) { return 'N/A' }
      if (!obj.receivedMovementPix) { return 'N/A' }
      if (!obj.receivedMovementPix.payerName) { return 'N/A' }
      return obj.receivedMovementPix.payerName
    },
    pixOriginCpfCnpj(obj) {
      if (obj.not_available) { return 'N/A' }
      if (!obj.receivedMovementPix) { return 'N/A' }
      if (!obj.receivedMovementPix.payerDocumentNumber) { return 'N/A' }

      return obj.receivedMovementPix.payerDocumentNumber
    },
    classFor(obj) {
      return (obj.nature === 'CREDIT') ? 'credit-line' : 'debit-line'
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  .search-filter .v-icon {
    color: #CCC!important;
  }
  .search-filter .v-text-field__slot input {
    color: #AAA!important;
  }
  table.v-table tbody tr.credit-line td span {
    color: #3bb59e!important;
  }
  table.v-table tbody tr.debit-line td span {
    color: #d64040!important;
  }
</style>




// WEBPACK FOOTER //
// src/AdminSmartbankStatement.vue